// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2K765","rootCenter":"LoadMoreObserver_rootCenter__2wyGk","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3FZRI"};